export default __webpack_public_path__ + "static/media/about-us-img2.4550be7d.png";